@file:OptIn(InternalResourceApi::class)

package studio.oddpods.cauce.feature.onboarding.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/studio.oddpods.cauce.feature.onboarding.generated.resources/"

internal val Res.string.onboarding_first_patient_error_limit_reached: StringResource by lazy {
      StringResource("string:onboarding_first_patient_error_limit_reached", "onboarding_first_patient_error_limit_reached", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 124),
      ))
    }

internal val Res.string.onboarding_first_patient_error_save_failed: StringResource by lazy {
      StringResource("string:onboarding_first_patient_error_save_failed", "onboarding_first_patient_error_save_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135, 102),
      ))
    }

internal val Res.string.onboarding_first_session_error_fee_invalid: StringResource by lazy {
      StringResource("string:onboarding_first_session_error_fee_invalid", "onboarding_first_session_error_fee_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238, 94),
      ))
    }

internal val Res.string.onboarding_first_session_error_limit_reached: StringResource by lazy {
      StringResource("string:onboarding_first_session_error_limit_reached", "onboarding_first_session_error_limit_reached", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 333, 120),
      ))
    }

internal val Res.string.onboarding_first_session_error_patient_required: StringResource by lazy {
      StringResource("string:onboarding_first_session_error_patient_required", "onboarding_first_session_error_patient_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 454, 87),
      ))
    }

internal val Res.string.onboarding_first_session_error_save_failed: StringResource by lazy {
      StringResource("string:onboarding_first_session_error_save_failed", "onboarding_first_session_error_save_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 542, 102),
      ))
    }

internal val Res.string.onboarding_notification_permission_description: StringResource by lazy {
      StringResource("string:onboarding_notification_permission_description", "onboarding_notification_permission_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 645, 178),
      ))
    }

internal val Res.string.onboarding_notification_permission_enable: StringResource by lazy {
      StringResource("string:onboarding_notification_permission_enable", "onboarding_notification_permission_enable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 824, 61),
      ))
    }

internal val Res.string.onboarding_notification_permission_not_now: StringResource by lazy {
      StringResource("string:onboarding_notification_permission_not_now", "onboarding_notification_permission_not_now", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 886, 62),
      ))
    }

internal val Res.string.onboarding_notification_permission_title: StringResource by lazy {
      StringResource("string:onboarding_notification_permission_title", "onboarding_notification_permission_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 949, 84),
      ))
    }

internal val Res.string.onboarding_profile_error_save_failed: StringResource by lazy {
      StringResource("string:onboarding_profile_error_save_failed", "onboarding_profile_error_save_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1034, 68),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("onboarding_first_patient_error_limit_reached", Res.string.onboarding_first_patient_error_limit_reached)
  map.put("onboarding_first_patient_error_save_failed", Res.string.onboarding_first_patient_error_save_failed)
  map.put("onboarding_first_session_error_fee_invalid", Res.string.onboarding_first_session_error_fee_invalid)
  map.put("onboarding_first_session_error_limit_reached", Res.string.onboarding_first_session_error_limit_reached)
  map.put("onboarding_first_session_error_patient_required", Res.string.onboarding_first_session_error_patient_required)
  map.put("onboarding_first_session_error_save_failed", Res.string.onboarding_first_session_error_save_failed)
  map.put("onboarding_notification_permission_description", Res.string.onboarding_notification_permission_description)
  map.put("onboarding_notification_permission_enable", Res.string.onboarding_notification_permission_enable)
  map.put("onboarding_notification_permission_not_now", Res.string.onboarding_notification_permission_not_now)
  map.put("onboarding_notification_permission_title", Res.string.onboarding_notification_permission_title)
  map.put("onboarding_profile_error_save_failed", Res.string.onboarding_profile_error_save_failed)
}
